import gql from 'graphql-tag';

const MUTATION_CREATE_SEMINAR_SIGNUP = gql`
	mutation CreateSeminarSignup($email: String!, $name: String!, $phone: String!, $type: Int!) {
		createSeminarSignup(email: $email, name: $name, phone: $phone, type: $type) 
	}
`;

export default MUTATION_CREATE_SEMINAR_SIGNUP;